import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';

platformBrowser()
    .bootstrapModule(AppModule, {
        ngZoneEventCoalescing: true
    })
    .then(() => {
        const splash = document.getElementById('boot-splash');
        if (splash) splash.remove();
    })
    .catch((err) => console.error(err));
